/**
 * Product Gallery Inline Zoom Feature
 * Pure CSS/JS implementation with mobile support
 */

document.addEventListener('DOMContentLoaded', function() {
  const mediaContainers = document.querySelectorAll('.product-media-container.media-type-image');
  
  mediaContainers.forEach((container, index) => {
    const image = container.querySelector('img');
    if (!image) return;
    
    let isZoomed = false;
    let originalModalId = null;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let isDragging = false;
    
    container.style.overflow = 'hidden';
    container.style.position = 'relative';
    
    const zoomOutIcon = document.createElement('div');
    zoomOutIcon.className = 'zoom-out-icon';
    zoomOutIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="none">
        <path d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M20.9992 21L14.9492 14.95" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 10H14" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    container.appendChild(zoomOutIcon);
    
    zoomOutIcon.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      exitZoom();
    });
    
    zoomOutIcon.addEventListener('touchstart', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      exitZoom();
    }, { passive: false });
    
    const modalOpener = container.querySelector('.product__modal-opener');
    const mediaToggle = container.querySelector('.product__media-toggle');
    
    container.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggleZoom(e);
    }, true);
    
    if (modalOpener) {
      modalOpener.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        toggleZoom(e);
      }, true);
    }
    
    if (mediaToggle) {
      mediaToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        toggleZoom(e);
      }, true);
    }
    
    function exitZoom() {
      image.style.transform = 'scale(1)';
      image.style.transformOrigin = 'center center';
      image.style.transition = 'transform 0.3s ease';
      
      container.classList.remove('zoomed');
      isZoomed = false;
      isDragging = false;
      
      zoomOutIcon.classList.remove('visible');
      
      if (modalOpener && originalModalId) {
        modalOpener.setAttribute('data-modal', originalModalId);
        modalOpener.style.pointerEvents = '';
      }
    }
    
    function toggleZoom(e) {
      if (!isZoomed) {
        
        const rect = container.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const clickY = e.clientY - rect.top;
        
        image.style.transformOrigin = `${clickX}px ${clickY}px`;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const offsetX = (clickX - centerX) / centerX;
        const offsetY = (clickY - centerY) / centerY;
        
        const mediaContainer = container.querySelector('.product__media.media.media--transparent');
        const mediaRect = mediaContainer ? mediaContainer.getBoundingClientRect() : rect;
        
        const imageRect = image.getBoundingClientRect();
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        
        const maxPanX = (imageWidth * 2 - mediaRect.width) / 2;
        const maxPanY = (imageHeight * 2 - mediaRect.height) / 2;
        
        const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const initialSensitivity = isMobile ? 50 : 100;
        
        const panX = Math.max(-maxPanX, Math.min(maxPanX, offsetX * initialSensitivity));
        const panY = Math.max(-maxPanY, Math.min(maxPanY, offsetY * initialSensitivity));
        
        image.style.transform = `scale(2) translate(${panX}px, ${panY}px)`;
        image.style.transition = 'transform 0.3s ease';
        
        container.classList.add('zoomed');
        isZoomed = true;
        
        zoomOutIcon.classList.add('visible');
        
        if (modalOpener) {
          originalModalId = modalOpener.getAttribute('data-modal');
          modalOpener.removeAttribute('data-modal');
          modalOpener.style.pointerEvents = 'none';
        }
      } else {
        exitZoom();
      }
    }
    
    container.addEventListener('mousemove', function(e) {
      if (!isZoomed) return;
      
      if (!isDragging) {
        const rect = container.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const offsetX = (mouseX - centerX) / centerX;
        const offsetY = (mouseY - centerY) / centerY;
        
        const mediaContainer = container.querySelector('.product__media.media.media--transparent');
        const mediaRect = mediaContainer ? mediaContainer.getBoundingClientRect() : rect;
        
        const imageRect = image.getBoundingClientRect();
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        
        const maxPanX = (imageWidth * 2 - mediaRect.width) / 2;
        const maxPanY = (imageHeight * 2 - mediaRect.height) / 2;
        
        const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const sensitivity = isMobile ? 50 : 100;
        
        const desiredPanX = offsetX * sensitivity;
        const desiredPanY = offsetY * sensitivity;
        
        const panX = Math.max(-maxPanX, Math.min(maxPanX, desiredPanX));
        const panY = Math.max(-maxPanY, Math.min(maxPanY, desiredPanY));
        
        image.style.transform = `scale(2) translate(${panX}px, ${panY}px)`;
        image.style.transition = 'none';
      }
    });
    
    container.addEventListener('mousedown', function(e) {
      if (!isZoomed) return;
      
      isDragging = true;
      
      const rect = container.getBoundingClientRect();
      startX = e.clientX - rect.left;
      startY = e.clientY - rect.top;
      
      const transform = image.style.transform;
      const translateMatch = transform.match(/translate\(([^,]+),([^)]+)\)/);
      if (translateMatch) {
        currentX = parseFloat(translateMatch[1]);
        currentY = parseFloat(translateMatch[2]);
      } else {
        currentX = 0;
        currentY = 0;
      }
      
      const handleDrag = function(e) {
        if (!isDragging) return;
        
        const rect = container.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        
        const deltaX = mouseX - startX;
        const deltaY = mouseY - startY;
        
        const mediaContainer = container.querySelector('.product__media.media.media--transparent');
        const mediaRect = mediaContainer ? mediaContainer.getBoundingClientRect() : rect;
        
        const imageRect = image.getBoundingClientRect();
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        
        const maxPanX = (imageWidth * 2 - mediaRect.width) / 2;
        const maxPanY = (imageHeight * 2 - mediaRect.height) / 2;
        
        const desiredX = currentX + deltaX;
        const desiredY = currentY + deltaY;
        
        const newX = Math.max(-maxPanX, Math.min(maxPanX, desiredX));
        const newY = Math.max(-maxPanY, Math.min(maxPanY, desiredY));
        
        image.style.transform = `scale(2) translate(${newX}px, ${newY}px)`;
        image.style.transition = 'none';
      };
      
      const handleMouseUp = function() {
        isDragging = false;
        
        const transform = image.style.transform;
        const translateMatch = transform.match(/translate\(([^,]+),([^)]+)\)/);
        if (translateMatch) {
          currentX = parseFloat(translateMatch[1]);
          currentY = parseFloat(translateMatch[2]);
        }
        
        document.removeEventListener('mousemove', handleDrag);
        document.removeEventListener('mouseup', handleMouseUp);
      };
      
      document.addEventListener('mousemove', handleDrag);
      document.addEventListener('mouseup', handleMouseUp);
    });
    
    container.addEventListener('mouseleave', function() {
      if (!isZoomed) return;
      
      isDragging = false;
      container.style.cursor = 'grab';
    });
    
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchCurrentY = 0;
    let isTouchDragging = false;
    let touchStartTime = 0;
    let touchMoved = false;
    
    container.addEventListener('touchstart', function(e) {
      if (!isZoomed) return;
      
      const touch = e.touches[0];
      const rect = container.getBoundingClientRect();
      
      touchStartX = touch.clientX - rect.left;
      touchStartY = touch.clientY - rect.top;
      touchStartTime = Date.now();
      touchMoved = false;
      
      const transform = image.style.transform;
      const translateMatch = transform.match(/translate\(([^,]+),([^)]+)\)/);
      if (translateMatch) {
        touchCurrentX = parseFloat(translateMatch[1]);
        touchCurrentY = parseFloat(translateMatch[2]);
      } else {
        touchCurrentX = 0;
        touchCurrentY = 0;
      }
      
      isTouchDragging = false;
    }, { passive: true });
    
    container.addEventListener('touchmove', function(e) {
      if (!isZoomed) return;
      
      const touch = e.touches[0];
      const rect = container.getBoundingClientRect();
      const touchX = touch.clientX - rect.left;
      const touchY = touch.clientY - rect.top;
      
      const deltaX = Math.abs(touchX - touchStartX);
      const deltaY = Math.abs(touchY - touchStartY);
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      
      if (distance > 10) {
        touchMoved = true;
        if (!isTouchDragging) {
          isTouchDragging = true;
          e.preventDefault();
        }
      }
      
      if (isTouchDragging) {
        e.preventDefault();
        
        const deltaX = (touchX - touchStartX) * 0.3;
        const deltaY = (touchY - touchStartY) * 0.3;
        
        const mediaContainer = container.querySelector('.product__media.media.media--transparent');
        const mediaRect = mediaContainer ? mediaContainer.getBoundingClientRect() : rect;
        
        const imageRect = image.getBoundingClientRect();
        const imageWidth = imageRect.width;
        const imageHeight = imageRect.height;
        
        const maxPanX = (imageWidth * 2 - mediaRect.width) / 2;
        const maxPanY = (imageHeight * 2 - mediaRect.height) / 2;
        
        const desiredX = touchCurrentX + deltaX;
        const desiredY = touchCurrentY + deltaY;
        
        const newX = Math.max(-maxPanX, Math.min(maxPanX, desiredX));
        const newY = Math.max(-maxPanY, Math.min(maxPanY, desiredY));
        
        image.style.transform = `scale(2) translate(${newX}px, ${newY}px)`;
        image.style.transition = 'none';
      }
    }, { passive: false });
    
    container.addEventListener('touchend', function(e) {
      if (!isZoomed) return;
      
      const touchDuration = Date.now() - touchStartTime;
      
      if (!touchMoved && touchDuration < 300) {
        e.preventDefault();
        exitZoom();
        return;
      }
      
      if (isTouchDragging) {
        e.preventDefault();
        
        const transform = image.style.transform;
        const translateMatch = transform.match(/translate\(([^,]+),([^)]+)\)/);
        if (translateMatch) {
          touchCurrentX = parseFloat(translateMatch[1]);
          touchCurrentY = parseFloat(translateMatch[2]);
        }
        
        isTouchDragging = false;
      }
    }, { passive: false });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isZoomed) {
        exitZoom();
      }
    });
  });
});
